'use client';

import { useEffect } from 'react';
import { MergedPriceAndAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { areEqualArrays } from 'components/price-and-fitment-context-entry/utils';
import { useAlternateContext } from './alternate-context-provider';

interface PriceAndAvailabilityContextEntryProps {
  alternatePriceAndAvailability: MergedPriceAndAvailabilityResponse[];
  listenerKey: string;
}

const PriceAndAvailabilityContextEntry = ({
  alternatePriceAndAvailability,
  listenerKey
}: PriceAndAvailabilityContextEntryProps) => {
  const { priceAndAvailability, setPriceAndAvailability } =
    useAlternateContext();

  useEffect(() => {
    const altDataArray = Object.keys(alternatePriceAndAvailability ?? {});
    const altContextArray = Object.keys(priceAndAvailability ?? {});
    if (
      !isEmpty(altDataArray) &&
      !areEqualArrays(altDataArray, altContextArray)
    ) {
      setPriceAndAvailability(alternatePriceAndAvailability);
    }
  }, [
    alternatePriceAndAvailability,
    listenerKey,
    priceAndAvailability,
    setPriceAndAvailability
  ]);

  return null;
};

export default PriceAndAvailabilityContextEntry;
